module.exports = __webpack_public_path__ + "img/ge.ad434906.jpg";